import moment from "moment";

export const initialDataState = {
  sort: [
    {
      field: "code",
      dir: "asc",
    },
  ],
};

export const VEHICLE_INFORMATION = {
  cashCenterId: "",
  officeId: "",
  fleetNo: "",
  registrationNo: "",
  make: "",
  model: "",
  manufacturingYear: moment().year(),
  vanType: "",
  engineNo: "",
  chassisNo: "",
  color: "",
  city: "",
  purchaseDate: null,
  registrationType: "",
  registrationYear: moment().year(),
  registrationExpiry: null,
  insurer: "",
  insuranceExpiry: null,
  armouredBy: "",
  armouringDate: null,
  lastFitnessDate: null,
  fitnessDueDate: null,
  fitnessInterval: "",
  fuelTag: true,
  cashLimit: "",
  status: "",
  issuedTo: "",
};
export const DEFAULT_VEHICLE = {
  ...VEHICLE_INFORMATION,
  installedLocks: [],
  pictures: [],
};

export const EMPTY_LOCK = {
  lockType: "",
  vender: "",
  lockSerilNo: "",
};
export const EMPTY_PICTURES = {
  fileName: "",
  contentType: "",
  contents: "",
};
export const LOCATION_TYPES = [
  {
    id: "Branch",
    text: "Branch",
  },
  {
    id: "VIP",
    text: "VIP",
  },
  {
    id: "Hub",
    text: "Hub",
  },
  {
    id: "ATM",
    text: "ATM",
  },
  {
    id: "CDM",
    text: "CDM",
  },
  {
    id: "Combo",
    text: "Combo",
  },
  {
    id: "ITM",
    text: "ITM",
  },
  {
    id: "Recycler",
    text: "Recycler",
  },
  {
    id: "KIOSK",
    text: "KIOSK",
  },
];

export const CATEGORY_LIST = [
  { id: "A", text: "A" },
  { id: "B", text: "B" },
  { id: "C", text: "C" },
];

export const SITE_TYPE_LIST = [
  {
    id: "CIT",
    text: "CIT",
  },
  {
    id: "Machine",
    text: "Machine",
  },
];

export const FIXING_SIDE = [
  {
    id: "Drive Up Island",
    text: "Drive Up Island",
  },
  {
    id: "Lobby Room Window",
    text: "Lobby Room Window",
  },
  {
    id: "Drive Up Kiosk",
    text: "Drive Up Kiosk",
  },
  {
    id: "Lobby Stand Alone",
    text: "Lobby Stand Alone",
  },
];

export const LOADING_SIDE_LIST = [
  { id: "Front", text: "Front" },
  { id: "Rear", text: "Rear" },
];

export const VEHICLE_TYPES = [
  {
    id: "soft Car",
    text: "Soft Car",
  },
  {
    id: "Cash Van",
    text: "Cash Van",
  },
];

export const STATUS_LIST = [
  {
    id: "Available",
    text: "Available",
  },
  {
    id: "Issued",
    text: "Issued",
  },
  {
    id: "Dispatched",
    text: "Dispatched",
  },
  {
    id: "Under Maintenance",
    text: "Under Maintenance",
  },
  {
    id: "Cannibalized",
    text: "Cannibalized",
  },
];

export const REGISTRATION_TYPES = [
  {
    id: "Armoured",
    text: "Armoured",
  },
  {
    id: "Non Armoured",
    text: "Non Armoured",
  },
];
